module.exports = __webpack_public_path__ + "img/shape-square.da175a90.svg";